import ChildrenEntities from 'client/components/core/ChildrenEntities'
import CommonColumn from 'common/components/entities/Column'
import { ColumnInterface } from 'common/components/entities/Column/types/ColumnInterface'
import React, { memo } from 'react'

interface ColumnProps {
  entity: ColumnInterface
  gridColumnStart: number
  disableStacking?: boolean
}

const Column = ({ entity, gridColumnStart, disableStacking }: ColumnProps) => (
  <CommonColumn
    entity={entity}
    gridColumnStart={gridColumnStart}
    disableStacking={disableStacking}
  >
    <ChildrenEntities
      id={entity.id}
      childIds={entity.childIds}
      type={entity.type}
      isReadOnly={entity.isReadOnly}
    />
  </CommonColumn>
)

export default memo(Column)
